import React, { useState, useEffect } from "react"
import { authFetch } from "../../lib/api"

const AdminQuoteRequests = () => {
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loadingList, setLoadingList] = useState(true)
  const [loadError, setLoadError] = useState("")

  useEffect(() => {
    let cancelled = false
    setLoadingList(true)
    setLoadError("")
    authFetch("/api/quote-requests?limit=100")
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return
        if (data.error) setLoadError(data.error)
        else {
          setList(data.quoteRequests || [])
          setTotal(data.total != null ? data.total : 0)
        }
      })
      .catch(() => {
        if (!cancelled) setLoadError("Could not load quote requests.")
      })
      .finally(() => {
        if (!cancelled) setLoadingList(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const formatDate = (d) => {
    if (!d) return "Not provided"
    const date = new Date(d)
    return `${date.toLocaleDateString(undefined, { dateStyle: "short" })} ${date.toLocaleTimeString(undefined, { timeStyle: "short" })}`
  }

  const trimMessage = (message) => {
    if (!message) return "No message"
    return message.length > 110 ? `${message.slice(0, 110)}...` : message
  }

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>Sales pipeline</span>
          <h2>Quote requests</h2>
          <p>Review service, build, and consultation requests submitted from the website.</p>
        </div>
        {!loadingList && <span className='admin-role-pill admin-role-pill--admin'>{total} total</span>}
      </div>

      {loadError && <p className='dashboard-error'>{loadError}</p>}
      {loadingList ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>No quote requests yet.</div>
      ) : (
        <div className='admin-table-wrap'>
          <table className='admin-table'>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={row.id}>
                  <td className='admin-table__muted'>{formatDate(row.createdAt)}</td>
                  <td><span className='admin-role-pill'>{row.type}</span></td>
                  <td><strong>{row.name}</strong></td>
                  <td><a href={`mailto:${row.email}`}>{row.email}</a></td>
                  <td className='admin-table__muted'>{row.phone || "Not provided"}</td>
                  <td className='admin-table__message'>{trimMessage(row.message)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}

export default AdminQuoteRequests
